// @ts-nocheck
import { productCarouselStyles, ProductCarouselStyles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(productCarouselStyles, {
    ...productCarouselStyles,
    mainContainer: {
        gap: 0,
        offsetCss: css`
            justify-content: center;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            text-align: center;
            margin-bottom: ${pxToRem(20)};
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                    css`
                        flex-basis: 5%;
                        max-width: 5%;
                    `,
                ])}
        `,
    },
} as ProductCarouselStyles);
